<template>
  <eg-dropdown
    class="rubric-actions-dropdown"
    menu-class="rubric-actions-dropdown-menu"
    boundary="window"
    right
    data-testid="rubric-actions-dropdown"
  >
    <template #button-content>
      <eg-icon icon="more-options-vertical-dots-dots" />
    </template>

    <eg-b-dropdown-item
      v-if="showShare && !isPlatformRubric"
      @click.stop="handleShare"
    >
      <eg-icon icon="collaboration" size="small" />
      <span class="paragraph-s">{{ $t("rubrics.rubricLinkItem") }}</span>
    </eg-b-dropdown-item>

    <eg-b-dropdown-divider v-if="showDelete && !isPlatformRubric" />

    <eg-b-dropdown-item
      v-if="showDelete && !isPlatformRubric"
      @click.stop="confirmDelete"
    >
      <eg-icon icon="delete" class="text-danger" size="small" />
      <span class="paragraph-s text-danger">{{ $t("common.delete") }}</span>
    </eg-b-dropdown-item>
  </eg-dropdown>
</template>

<script>
import EgDropdown from "@/components/global/eg_dropdown.vue";

export default {
  name: "RubricActionsDropdown",

  components: {
    EgDropdown,
  },

  props: {
    rubric: {
      type: Object,
      required: true,
    },
    showShare: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    isPlatformRubric() {
      return this.rubric.type === "system";
    },
  },

  methods: {
    handleShare() {
      this.$emit("share", this.rubric);
    },

    async confirmDelete() {
      const isConfirmed = await this.$showDeleteConfirmationModal({
        title: this.$t("rubrics.deleteRubricConfirm"),
        message: this.$t("rubrics.rubricCannotBeAccessed"),
      });

      if (isConfirmed) {
        this.$emit("delete", [this.rubric.id]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rubric-actions-dropdown {
  ::v-deep .dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;

    &:hover {
      background-color: var(--color-surface-neutral-container-1, #f6f8fa);
    }

    .text-danger {
      color: var(--color-text-error-default, #dc3545);
    }
  }
}

.rubric-actions-dropdown-menu {
  ::v-deep .items-wrapper {
    padding: 8px 0;
  }
}
</style>
